export default __webpack_public_path__ + "static/media/1521.d35a5389.png";